module.exports = __webpack_public_path__ + "img/capa.5876199f.png";